import videoLeftTopCorner from 'images/video_left_top_corner.svg';
import videoLeftBottomCorner from 'images/video_left_bottom_corner.svg';
import baloon from 'images/baloon.svg';
import React, {useState} from 'react';
import styled from 'styled-components';
import {useTranslation} from 'gatsby-plugin-react-i18next';

const VideoSection = styled.div`
  position: absolute;
  left: 50%;
  top: 150px;
  z-index: 1;

  @media (max-width: 1280px) {
    position: relative;
    left: auto;
    top: auto;
    margin: 24px auto;
  }
`;

const MoneiPayVideo = styled.iframe`
  position: relative;
  left: 50px;
  width: 580px;
  height: 326px;
  border: 0;
  @media (max-width: 1280px) {
    left: 0;
  }
  @media (max-width: 768px) {
    width: 90vw;
  }
`;

const VideoLeftTopCorner = styled.img`
  position: absolute;
  left: 29px;
  top: -19px;

  @media (max-width: 1280px) {
    left: -19px;
  }
`;

const VideoLeftBottomCorner = styled.img`
  position: absolute;
  left: -9px;
  bottom: -53px;

  @media (max-width: 1280px) {
    left: -55px;
  }
`;

const VideoPoster = styled.div<{posterUrl: string}>`
  position: relative;
  left: 50px;
  width: 580px;
  height: 326px;
  cursor: pointer;
  background-image: url(${(props) => props.posterUrl});
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 1280px) {
    left: 0;
  }
  @media (max-width: 768px) {
    width: 90vw;
    height: calc(90vw * 9 / 16);
  }
`;

const PlayButton = styled.div`
  width: 68px;
  height: 48px;
  background: #ff0000;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.15s ease;

  ${VideoPoster}:hover & {
    transform: scale(1.1);
  }

  &::after {
    content: '';
    border-style: solid;
    border-width: 10px 0 10px 18px;
    border-color: transparent transparent transparent #fff;
    margin-left: 4px;
  }
`;

const Baloon = styled.img`
  position: absolute;
  bottom: -75px;
  right: -109px;
  width: 125px;
  @media (max-width: 1280px) {
    right: -65px;
  }
  @media (max-width: 768px) {
    display: none;
  }
`;

interface MoneiVideoSectionProps {
  src?: string;
  title?: string;
  showBalloon?: boolean;
  poster?: string;
}

export const MoneiVideoSection: React.FC<MoneiVideoSectionProps> = ({
  src = 'https://www.youtube.com/embed/eYk6CCh-XaM',
  title: titleProp,
  showBalloon = true,
  poster
}) => {
  const {t} = useTranslation();
  const [active, setActive] = useState(false);
  const resolvedTitle = titleProp ?? t('TPV sin datáfono de MONEI : tu móvil = tu TPV');

  return (
    <VideoSection>
      <VideoLeftTopCorner src={videoLeftTopCorner} />
      <VideoLeftBottomCorner src={videoLeftBottomCorner} />
      {poster && !active ? (
        <VideoPoster
          posterUrl={poster}
          onClick={() => setActive(true)}
          role="button"
          aria-label={resolvedTitle}>
          <PlayButton />
        </VideoPoster>
      ) : (
        <MoneiPayVideo
          src={src}
          title={resolvedTitle}
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; allowfullscreen; clipboard-write"
        />
      )}
      {showBalloon && <Baloon src={baloon} alt="MONEI" title="MONEI" />}
    </VideoSection>
  );
};
